// Адрес api: при сборке — VITE_API_URL (Supabase Cloud для разработки, self-hosted в РФ — для прода).
export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:54321/functions/v1/api';
export const APP_URL = location.origin + '/';
